import { KeyValueGambit } from 'flarum/common/query/IGambit';
import app from 'flarum/common/app';
export default class MentionedGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('flarum-mentions.lib.gambits.posts.mentioned.key', {}, true);
  }
  hint() {
    return app.translator.trans('flarum-mentions.lib.gambits.posts.mentioned.hint', {}, true);
  }
  filterKey() {
    return 'mentioned';
  }
}
flarum.reg.add('flarum-mentions', 'common/query/posts/MentionedGambit', MentionedGambit);